import React from 'react';
import ScrollerContext from '../../ScrollerContext';

/**
 * connectToPlayer
 * @param Component
 * @returns {React.Component}
 */
export const connectToScroller = (Component) => function ScrollerComponent(props) {
  return (
    <ScrollerContext.Consumer>
      {(state) => {
        const newProps = { ...state, ...props };
        return (<Component {...newProps} scrollerContext={state} />);
      }}
    </ScrollerContext.Consumer>
  );
};

export default connectToScroller;
